export default __webpack_public_path__ + "assets/moon-last-quarter.413f8fc9.svg";